<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <TableEmpresas/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableEmpresas from '@/router/views/admin/components/table-empresas'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Empresas Liberadas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableEmpresas
  },
  data() {
    return {
      title: "Empresas Autorizadas",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Empresas Autorizadas',
          active: true,
        },
      ],
    };
  },
  mounted() {
  },
};
</script>


